var _excluded = ["analysisType"],
    _excluded2 = ["filters", "orderBy", "propertyNames", "steps"],
    _excluded3 = ["id"],
    _excluded4 = ["id"],
    _excluded5 = ["id"],
    _excluded6 = ["id"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import snakeCase from 'snakecase-keys';
import { convertAbstractOperators } from './convertAbstractOperators';
import { FIELDS_CONFIG } from '../config';
export var transformToQuery = function transformToQuery(query) {
  var analysisType = query.analysisType,
      queryProperties = _objectWithoutProperties(query, _excluded);

  var queryCopy = _objectSpread({}, queryProperties);

  Object.keys(queryProperties).forEach(function (fieldName) {
    var fieldConfig = FIELDS_CONFIG[fieldName];

    if (fieldConfig && !fieldConfig.includes(analysisType)) {
      delete queryCopy[fieldName];
    }
  });

  var filters = queryCopy.filters,
      orderBy = queryCopy.orderBy,
      propertyNames = queryCopy.propertyNames,
      steps = queryCopy.steps,
      restQuerySettings = _objectWithoutProperties(queryCopy, _excluded2);

  var queryToTransform = _objectSpread({
    analysisType: analysisType
  }, restQuerySettings);

  if (filters) {
    queryToTransform.filters = filters.map(function (_ref) {
      var id = _ref.id,
          filter = _objectWithoutProperties(_ref, _excluded3);

      return convertAbstractOperators(filter);
    });
  }

  if (orderBy) {
    queryToTransform.orderBy = orderBy.map(function (_ref2) {
      var id = _ref2.id,
          item = _objectWithoutProperties(_ref2, _excluded4);

      return item;
    });
  }

  if (propertyNames) {
    queryToTransform.propertyNames = queryCopy.propertyNames.map(function (_ref3) {
      var id = _ref3.id,
          propertyName = _ref3.propertyName;
      return propertyName;
    });
  }

  if (steps) {
    queryToTransform.steps = steps.map(function (_ref4) {
      var id = _ref4.id,
          step = _objectWithoutProperties(_ref4, _excluded5);

      return _objectSpread(_objectSpread({}, step), {}, {
        filters: step.filters.map(function (_ref5) {
          var id = _ref5.id,
              filter = _objectWithoutProperties(_ref5, _excluded6);

          return convertAbstractOperators(filter);
        })
      });
    });
  }

  return snakeCase(queryToTransform);
};